// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playmaker-modal{width:800px;max-height:500px}.players-grid{max-height:450px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
